import { render, staticRenderFns } from "./ComparativeTableLotGroups.vue?vue&type=template&id=3bd8a8fe&scoped=true"
import script from "./ComparativeTableLotGroups.vue?vue&type=script&lang=js"
export * from "./ComparativeTableLotGroups.vue?vue&type=script&lang=js"
import style0 from "./ComparativeTableLotGroups.vue?vue&type=style&index=0&id=3bd8a8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8a8fe",
  null
  
)

export default component.exports